import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const ShieldIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <path
            d="M12 3.13433L3.99377 6.48704C3.73564 6.59505 3.59564 6.82404 3.60002 7.04006C3.62189 10.989 5.28001 17.8111 11.755 20.87C11.9125 20.9434 12.0962 20.9434 12.2494 20.87C18.7244 17.8068 20.3825 10.989 20.4 7.03574C20.4 6.81972 20.2644 6.59505 20.0062 6.48272L12 3.13433ZM12.5862 1.12529L20.8244 4.57738C21.7869 4.97918 22.5044 5.91673 22.5 7.0487C22.4781 11.3346 20.6931 19.1764 13.155 22.7408C12.4244 23.0864 11.5756 23.0864 10.845 22.7408C3.30689 19.1764 1.52189 11.3346 1.50002 7.0487C1.49564 5.91673 2.21314 4.97918 3.17564 4.57738L11.4181 1.12529C11.5975 1.04321 11.7988 1 12 1C12.2013 1 12.4025 1.04321 12.5862 1.12529Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default ShieldIcon
